export const createLightTheme = {
  '--create-bgc-1': '#65d5ff',
  '--create-bgc-2': '#9fa7b3',
  '--create-bgc-3': '#f8f8f8',
  '--create-bgc-4': 'linear-gradient(341deg, #0989e5 9%, #37dffd 83%)',
  '--create-bgc-5': 'linear-gradient(122deg, #238ec9 12%, #354acc 86%)',
  '--create-bgc-6': 'linear-gradient(90deg, #37dffd, #0a8ae5)',
  '--create-bgc-7': '#f8f8f8',
  '--create-bgc-8': '#f8f8f8',
  '--create-bgc-9': '#343b4a',
  '--create-bgc-10': '#fff',
  '--create-font-c-1': '#333',
  '--create-font-c-2': '#f75b3d',
  '--create-font-c-3': '#666',
  '--create-font-c-4': '#65d5ff',
  '--create-font-c-5': '#23262f',
  '--create-font-c-6': '#fff',
  '--create-font-c-7': '#4d5465',
  '--create-font-c-8': '#fb3225',
  '--create-font-c-9': '#fb3225',
  '--create-font-c-10': '#fff',
  '--create-icon-font-c-1': '#65d5ff',
  '--create-border-c-1': '#65d5ff',
  '--create-border-c-2': '#37DFFD',
  '--create-border-c-3': '#333',
  '--create-border-c-4': '#f75b3d',
  '--create-border-c-5': '#4d5465',
  '--create-border-c-6': '#eee',
  '--create-border-c-7': '#9fa7b3',
}
export const createDarkTheme = {
  '--create-bgc-1': '#65d5ff',
  '--create-bgc-2': '#9fa7b3',
  '--create-bgc-3': '#23262f',
  '--create-bgc-4': 'linear-gradient(341deg, #0989e5 9%, #37dffd 83%)',
  '--create-bgc-5': 'linear-gradient(122deg, #238ec9 12%, #354acc 86%)',
  '--create-bgc-6': 'linear-gradient(90deg, #37dffd, #0a8ae5)',
  '--create-bgc-7': '#373b46',
  '--create-bgc-8': '#3d414d',
  '--create-bgc-9': '#343b4a',
  '--create-bgc-10': '#23262f',
  '--create-font-c-1': '#fff',
  '--create-font-c-2': '#f75b3d',
  '--create-font-c-3': '#9fa7b3',
  '--create-font-c-4': '#65d5ff',
  '--create-font-c-5': '#23262f',
  '--create-font-c-6': '#000',
  '--create-font-c-7': '#4d5465',
  '--create-font-c-8': '#fb3225',
  '--create-font-c-9': '#fb3225',
  '--create-font-c-10': '#fff',
  '--create-icon-font-c-1': '#fff',
  '--create-border-c-1': '#65d5ff',
  '--create-border-c-2': '#37DFFD',
  '--create-border-c-3': '#fff',
  '--create-border-c-4': '#f75b3d',
  '--create-border-c-5': '#4d5465',
  '--create-border-c-6': '#3b3e49',
  '--create-border-c-7': '#9fa7b3',
}
